import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_END_POINTS, BASE_URL } from "../ApiEndPoints";
import axios from "axios";
import globalFunction from "../../utils/globalFunction";

const initialState = {
  isLoading: false,
  isError: false,
  message: null,
};
const handleUnauthorizedError = (message) => {
  if (
    message === "Unauthorized" ||
    message?.toLowerCase().includes("user not authorized") ||
    message?.toLowerCase().includes("token has expired") ||
    message?.toLowerCase().includes("jwt expire")
  ) {
    globalFunction.logoutFunction();
  }
};

export const studentAddEducationAPI = createAsyncThunk(
  "studentAddEducationAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.studentAddEducation,
        credentials.payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const studentAddExperienceAPI = createAsyncThunk(
  "studentAddExperienceAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.studentAddExperience,
        credentials.payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

// Ahsan Code
export const studentFavoriteCourseApi = createAsyncThunk(
  "studentFavoriteCourseApi",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.studentFavoriteCourse, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);
export const studentEnrolledCourseApi = createAsyncThunk(
  "studentEnrolledCourseApi",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.studentEnrolledCourse, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);
export const studentAllCourseCategoriesApi = createAsyncThunk(
  "studentAllCourseCategoriesApi",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        API_END_POINTS.studentAllCourseCategories,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const studentAllCourseAPI = createAsyncThunk(
  "studentAllCourseAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.studentCourses, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const createStudentFavoriteCourseApi = createAsyncThunk(
  "createStudentFavoriteCourseApi",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.studentCourses +
          "/" +
          credentials.courseId +
          "/favorites",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const removeStudentFavoriteCourseApi = createAsyncThunk(
  "removeStudentFavoriteCourseApi",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        API_END_POINTS.studentCourses +
          "/" +
          credentials.courseId +
          "/favorites",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const getAllEnrolledStudentAPI = createAsyncThunk(
  "getAllEnrolledStudentAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.enrolledAllStudent, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        // handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);
export const studentCompletedCourseAPI = createAsyncThunk(
  "studentCompletedCourseAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.studentCompletedCourse, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        // handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);
export const getAllstudentCourseAPI = createAsyncThunk(
  "getAllstudentCourseAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.getAllstudentCourse, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        // handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);
export const getAllstudentCertificateAPI = createAsyncThunk(
  "getAllstudentCertificateAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        API_END_POINTS.getAllstudentCertificate,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        // handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const getCertificateByIdForStudentCertificate = createAsyncThunk(
  "getCertificateByIdForStudentCertificate",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        BASE_URL + `student/certificate/${credentials.certificateId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const studentArticleReadApi = createAsyncThunk(
  "studentArticleReadApi",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.studentArticle + "/" + credentials.articleId + "/read",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const studentVideoWatchedApi = createAsyncThunk(
  "studentVideoWatchedApi",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.studentVideos + `/${credentials?.videoId}/view`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const getAllstudentCertificateRequestsAPI = createAsyncThunk(
  "getAllstudentCertificateRequestsAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        API_END_POINTS.getAllstudentCertificateRequests,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const studentRequestCertificateAPI = createAsyncThunk(
  "studentRequestCertificate",
  async ({ token, courseId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.studentRequestCertificate,
        { courseId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAllStudentApprovedCertificatesAPI = createAsyncThunk(
  "getAllStudentApprovedCertificatesAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        API_END_POINTS.getAllStudentApprovedCertificate,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

const studentDetailSlice = createSlice({
  name: "student",
  initialState,
  reducers: {},
});

export default studentDetailSlice.reducer;
